import React from 'react';

export default function HtmlBody({ html }) {
  if (!html) return null;
  return (
    <div
      className="prose prose-sm max-w-none text-sm text-gray-600 prose-headings:font-semibold prose-headings:tracking-tight prose-headings:text-gray-900 prose-a:text-gray-900 prose-a:underline"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
